// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2iRwp","insightsList":"newBusinessInsightsMenu_insightsList__2CQTc","active":"newBusinessInsightsMenu_active__WXt59"};